import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchEventsRoutePathByLocale = {
  en: '/en/events',
  es: '/es/eventos',
  pt: '/pt/eventos',
} satisfies Record<I18nLocale, string>;

export const searchEventsRoutePaths = Object.values(
  searchEventsRoutePathByLocale,
);

export const searchEventsRoutePathsWithoutLang = Array.from(
  new Set(searchEventsRoutePaths.map((path) => path.substring(3))),
);
